<template>
  <div class="tabbar">
    <div class="tabbar__placeholder">
      <router-view />
    </div>
    <keep-alive>
      <Tabbar class="app-tabbar" v-model="active" :active-color="verConfig.tabbar.selectedColor || verConfig.theme"
        inactive-color="#9d9d9d" route fixed>
        <TabbarItem v-for="(item, index) in verConfig.tabbar.pages" :key="index" :name="index"
          :to="`/tabbar/${item.pagePath}`">
          <span>{{ $t(item.text) }}</span>
          <template #icon="props">
            <img v-if="verConfig.tabbar.type === 'image'" :src="props.active ? item.selectedIconPath : item.iconPath"
              alt="" />
            <img v-else-if="item.type === 'image'" :src="props.active ? item.selectedIconPath : item.iconPath" alt="" />
            <i class="iconfont" v-else :class="item.selectedIconPath
                ? props.active
                  ? item.selectedIconPath
                  : item.iconPath
                : item.iconPath
              "></i>
          </template>
        </TabbarItem>
      </Tabbar>
    </keep-alive>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  components: {
    Tabbar,
    TabbarItem,
  },
  data: () => ({
    // active: 0,
  }),
  created() { },
  methods: {
    handleClick() { },
  },
  computed: {
    active: {
      get() {
        return this.$store.state.tabbar.active;
      },
      set(newVal) {
        return newVal;
      },
    },
  },
};
</script>

<style lang="less" scoped>
.tabbar {
  background: var(--page-background);

  &__placeholder {
    padding-bottom: 72px;
  }

  /deep/ .app-tabbar {
    position: fixed !important;
    z-index: 100;
    right: auto;
    bottom: 0 !important;
    left: 50% !important;
    max-width: 726px;
    height: 72px;
    padding: 7px 10px max(10px, env(safe-area-inset-bottom));
    box-sizing: border-box;
    transform: translateX(-50%);
    text-align: center;
    background: var(--color-surface);
    border: 1px solid var(--color-primary-border);
    border-radius: 28px 28px 0 0;
    box-shadow: 0 -7px 24px rgba(73, 55, 18, 0.06);

    &::after {
      display: none;
    }
  }

  /deep/ .van-tabbar-item {
    color: #9d9d9d;
    background: transparent;
  }

  /deep/ .van-tabbar-item--active {
    color: var(--color-primary-strong);
  }

  /deep/ .van-tabbar-item__icon {
    margin-bottom: 4px;

    img {
      width: 24px;
      height: 24px;
      display: block;
      object-fit: contain;
    }
  }

  /deep/ .van-tabbar-item__text {
    max-width: 72px;
    overflow: hidden;
    font-size: 11px;
    font-weight: 500;
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.iconfont {
  font-size: 25px;
}
</style>
